import { SVGProps } from 'react'

export const Download = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.25 12.5V13.5C18.25 14.9001 18.25 15.6002 17.9775 16.135C17.7378 16.6054 17.3554 16.9878 16.885 17.2275C16.3502 17.5 15.6501 17.5 14.25 17.5H7.25C5.84987 17.5 5.1498 17.5 4.61502 17.2275C4.14462 16.9878 3.76217 16.6054 3.52248 16.135C3.25 15.6002 3.25 14.9001 3.25 13.5V12.5M14.9167 8.33333L10.75 12.5M10.75 12.5L6.58333 8.33333M10.75 12.5V2.5"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
